import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"brush"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10.5 2.5L7 6L18 17L21.5 13.5L18 10L21 7L17 3L14 6L10.5 2.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M1.5 11.5L12.5 22.5L18 17L7 6L1.5 11.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 6L18 17M7 6L1.5 11.5L12.5 22.5L18 17M7 6L10.5 2.5L14 6L17 3L21 7L18 10L21.5 13.5L18 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Brush = Vue.extend<IconProps>({
  name: 'BrushIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'brush',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Brush;
